import { render, staticRenderFns } from "./ChecklistOverview.vue?vue&type=template&id=b3622548&scoped=true&"
import script from "./ChecklistOverview.vue?vue&type=script&lang=ts&"
export * from "./ChecklistOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ChecklistOverview.vue?vue&type=style&index=0&id=b3622548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3622548",
  null
  
)

export default component.exports